function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ApplicationInstance from "@ember/application/instance";
import { getOwner } from "@ember/owner";
import Service from "@ember/service";
import CoreAdapter from "core/adapters/core";
export default class ExternalMedicAuthService extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "applicationAdapter", getOwner(this).lookup("adapter:application"));
  }
  async generateMagicLink() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/api/v1/magic_link", true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onload = function () {
        if (this.readyState === 4 && this.status === 201) {
          resolve(JSON.parse(this.responseText).data?.attributes?.link);
        } else {
          reject(new Error(xhr.statusText));
        }
      };
      for (const key in this.applicationAdapter.headers) {
        if (this.applicationAdapter.headers.hasOwnProperty(key)) {
          xhr.setRequestHeader(key, this.applicationAdapter.headers[key]);
        }
      }
      xhr.send();
    });
  }
}